// extracted by mini-css-extract-plugin
module.exports = {"print":"collapse_print__mkE_H","stock":"collapse_stock__xMZVx"};